export const environment = {
  production: true,
  apiUrl: 'https://bioid-pro-we.azurewebsites.net',
  recommendationsUrl: 'https://fundacionmutualidad.org/bio-id-3/',
};
